import { getProjectDateRange } from '#helper';

export const isDataExist = obj => obj && Object.values(obj).some(v => v.length);

export const getShipmentsData = shipments => {
  const result = {};
  const finishedStatus = 500;
  const shipmentsLength = shipments?.length;

  if (shipmentsLength) {
    const mergedStatuses = [300, 400];
    shipments.forEach(sipment => {
      if (!sipment?.status) {
        return false;
      }
      if (mergedStatuses.includes(sipment.status)) {
        if (!result[finishedStatus]) result[finishedStatus] = [];
        result[finishedStatus].push(sipment);
      } else {
        if (!result[sipment.status]) result[sipment.status] = [];
        result[sipment.status].push(sipment);
      }
      return result;
    });
  }

  return result;
};

export const getDateData = (delivery, account) => {
  const minMaxDate = {};
  let shipmentDateRange = '';
  const beginDate = (delivery[0] && delivery[0].date) || new Date();
  const endDate = (delivery.length > 1 && delivery[delivery.length - 1].date) || null;

  minMaxDate.minDate = new Date(beginDate);
  const opt = {};
  opt.beginDate = beginDate;

  if (endDate) {
    minMaxDate.maxDate = new Date(endDate);
    opt.expirationDate = endDate;
  }

  shipmentDateRange = getProjectDateRange(opt, account && account.measurementSystem, 'dateTimeShort');

  return {
    minMaxDate,
    shipmentDateRange
  };
};
